export const defaultColumns = [
  {label: 'Categorias', value: 'categoryName'},
  {label: 'Nome', value: 'display_name'},
  {label: 'Códigos Fiserv', value: 'tef_identifiers'},
  {label: 'Métrica', value: 'unit_for_quantity', className: 'w-fit'},
  {label: 'Ações', value: 'actions', className: 'w-9'},
]
